import dayjs from 'dayjs';
import useAxios from 'hooks/useAxios';

export const getEmailSummary = async (dateFrom = '', dateTo = '') => {
  try {
    const api = useAxios();

    if (dateFrom === '' || !dateFrom) {
      dateFrom = dayjs('2000-01-01').startOf('day').toISOString();
    } else {
      dateFrom = dayjs(dateFrom).startOf('day').toISOString();
    }

    if (dateTo === '' || !dateTo) {
      dateTo = dayjs().endOf('day').toISOString();
    } else {
      dateTo = dayjs(dateTo).endOf('day').toISOString();
    }

    const res = await api.get(`/v1/metric/statistic-for-period`, {
      params: {
        startDate: dateFrom,
        endDate: dateTo
      }
    });

    return res;
  } catch (error) {
    console.log(error);
    return {
      data: []
    };
  }
};
